import { InjectionToken } from "@angular/core";

import { FoundsApi } from "./founds.api.interface";

export const FOUNDS_API = new InjectionToken<FoundsApi>('FOUNDS_API');